// extracted by mini-css-extract-plugin
module.exports = {"nav__logoutDesktop":"nav-logout_nav__logoutDesktop__iubO_","nav__logoutMobile":"nav-logout_nav__logoutMobile__5_zlv","nav__logoutText":"nav-logout_nav__logoutText__DrElR"};